export const WISHLIST_STORAGE_KEY = 'qubeyards-wishlist';

const canUseWindow = () => typeof window !== 'undefined' && window.localStorage;

const normalizeWishlistItem = (item) => ({
  id: item?.id || item?.title || item?.location || `wishlist-${Date.now()}`,
  title: item?.title || item?.name || item?.type || 'Property',
  location: item?.location || item?.city || 'Location on request',
  price: item?.price || item?.priceRange || 'Price on request',
  type: item?.type || item?.status || item?.category || 'Property',
  configuration: item?.configuration || item?.config || item?.subCategory || 'Details on request',
  image: item?.image || item?.imageUrl || '',
  description: item?.description || item?.details || 'Newly shortlisted property.',
  category: item?.category || item?.type || 'Property',
  city: item?.city || item?.location || '',
  state: item?.state || '',
  country: item?.country || '',
  addedAt: item?.addedAt || Date.now(),
});

export const readWishlist = () => {
  if (!canUseWindow()) {
    return [];
  }

  try {
    const rawWishlist = window.localStorage.getItem(WISHLIST_STORAGE_KEY);
    return rawWishlist ? JSON.parse(rawWishlist).map(normalizeWishlistItem) : [];
  } catch {
    return [];
  }
};

export const writeWishlist = (wishlist) => {
  if (!canUseWindow()) {
    return wishlist;
  }

  const nextWishlist = (wishlist || []).map(normalizeWishlistItem);
  window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(nextWishlist));
  return nextWishlist;
};

export const toggleWishlistItem = (item, currentWishlist = []) => {
  const normalizedItem = normalizeWishlistItem(item);
  const exists = currentWishlist.some((entry) => entry.id === normalizedItem.id);

  if (exists) {
    return currentWishlist.filter((entry) => entry.id !== normalizedItem.id);
  }

  return [normalizedItem, ...currentWishlist];
};

export const isWishlisted = (item, currentWishlist = []) => {
  const key = normalizeWishlistItem(item).id;
  return currentWishlist.some((entry) => entry.id === key);
};
